import {
  getUserRegistrationStatus, statusAndProcessEntryCode, saveNewUser, confirmRegisteredUserEmail, getLoggedInUserForPresentation, getUserInformation, saveUserConsentToPolicy, hasConsentedToPrivacyPolicy,
  getCountries, verifyUserInformation, completeUserProfile, getAccountTypes, getCompanyRoles, getPresenterRegBypass, getCompanySuggestions
} from '@/service/api';
import { getUrlQueryParam, getAllUrlQueryParam, skipMissingInfoPage } from '@/utils/helper';
import { storeEmailAddressInSession } from '@/utils/helper';
import Enums from '@/utils/enums';
import {
  FETCH_UPDATE,
  FETCH_FAILURE,
  FETCH_USER_REGISTRATION_DETAILS_SUCCESS,
  SAVE_NEW_USER_SUCCESS,
  POST_CONFIRM_EMAIL_SUCCESS,
  SAVE_NEW_USER_FAILURE,
  POST_CONFIRM_EMAIL_FAILURE,
  FETCH_LOGGED_IN_USER_DETAILS_SUCCESS,
  FETCH_USER_INFORMATION_SUCCESS,
  FETCH_USER_INFORMATION_FAILURE,
  FETCH_COMPANY_SUGGESTIONS_SUCCESS,
  FETCH_COMPANY_SUGGESTIONS_FAILURE,
  FETCH_COUNTRIES_SUCCESS,
  FETCH_COUNTRIES_FAILURE,
  SET_PRIVACY_POLICY_FLAG,
  SET_PRIVACY_POLICY_ERROR_MESSAGE,
  SET_MISSING_INFO_STATUS,
  COMPLETE_PROFILE_SUCCESS,
  COMPLETE_PROFILE_FAILURE,
  SET_USER_PRIMARY_EMAIL,
  FETCH_ACCOUNT_TYPES_SUCCESS,
  FETCH_ACCOUNT_TYPES_FAILURE,
  FETCH_COMPANY_ROLES_SUCCESS,
  RESET_COMPANY_ROLES_ON_LANG_CHANGE,
  FETCH_COMPANY_ROLES_FAILURE,
  SET_PRESENTER_REG_BYPASS,
  SET_IS_USER_PRESENTER,
  SET_PRIVACY_CONSENT_DATA,
} from '@/store/actions';

import { commitLocalAndToGlobalService, globalCommit, globalDispatch } from '@/utils/vuex';
import { onRouteInitialize, getRedirectUrlForNotRegisteredUser } from '@/service/routerService';
import Constants from '@/utils/constants';
export const IS_VALID_EMAIL = 'IS_VALID_EMAIL';
export const REDIRECT_PATH = 'REDIRECT_PATH';
export const USER_EMAIL_ADDRESS = 'USER_EMAIL_ADDRESS';

export const LoginModule = {
  namespaced: true,
  state: {
    userEmailAddress: '',
    userRegistrationStatus: 0,
    isRegisterPostSuccess: {},
    isCompleteProfileSuccess: {},
    isEmailConfirmed: '',
    isValidEmail: true,
    redirectTo: '',
    loggedInUser: {},
    countries: [],
    showPrivacyPolicyModal: false,
    privacyPolicyErrorMessage: '',
    isMissingInformation: {},
    userInformation: {},
    companySuggestions: [],
    primaryEmail: '',
    accountTypes: [],
    companyRoles: {},
    canBypassRegistration: null,
    isUserPresenter: false,
    privacyConsentData: {},
  },

  actions: {

    async loginUser({ commit, dispatch }, emailAddress) {
      globalCommit('service', commit, FETCH_UPDATE);

      try {
        dispatch('onUserRegistrationStatus', emailAddress);
      }
      catch (error) {
        const errorMessage = error.response.data ? error.response.data.Error : '';
        globalCommit('service', commit, FETCH_FAILURE, errorMessage);
      }
      globalCommit('service', commit, FETCH_UPDATE);
    },

    async fetchUserRegistrationStatus({ commit, state }, params) {
      globalCommit('service', commit, FETCH_UPDATE);
      try {
        const userRegistrationStatus = await getUserRegistrationStatus(params);
        commitLocalAndToGlobalService(commit, FETCH_USER_REGISTRATION_DETAILS_SUCCESS, userRegistrationStatus.data);
      } catch (error) {
        if (state.canBypassRegistration) {
          commitLocalAndToGlobalService(commit, FETCH_USER_REGISTRATION_DETAILS_SUCCESS, { "Status": error.response.data.ErrorCode });
          commitLocalAndToGlobalService(commit, SET_USER_PRIMARY_EMAIL, error.response.data.EmailAddress);
        } else if (error.response.data && error.response.data.ErrorCode === 1) { // If failure is due to Unconfirmed email, then raise a success event
          commitLocalAndToGlobalService(commit, FETCH_USER_REGISTRATION_DETAILS_SUCCESS, { "Status": Enums.UserRegistrationStatus.RegisteredUnconfirmedWithoutAccount });
          commitLocalAndToGlobalService(commit, SET_USER_PRIMARY_EMAIL, error.response.data.EmailAddress);   
        } else {
          globalCommit('service', commit, FETCH_FAILURE, Constants.ErrorMessages.GenericToasterErrorMessage);
        }
      }
    },

    async protectedFetchUserRegistrationStatus({ commit, state, dispatch }, params) {
      globalCommit('service', commit, FETCH_UPDATE);
      try {
        const response = await statusAndProcessEntryCode(params);
        commitLocalAndToGlobalService(commit, FETCH_USER_REGISTRATION_DETAILS_SUCCESS, response.data.Status);
        if(response.data.LogId) {
          await globalDispatch('presentation', dispatch, 'commitLogId', response.data.LogId);
        }
      } catch (error) {
        if (state.canBypassRegistration) {
          commitLocalAndToGlobalService(commit, FETCH_USER_REGISTRATION_DETAILS_SUCCESS, { "Status": error.response.data.ErrorCode });
          commitLocalAndToGlobalService(commit, SET_USER_PRIMARY_EMAIL, error.response.data.EmailAddress);
        } else if (error.response.data && error.response.data.ErrorCode === 1) { // If failure is due to Unconfirmed email, then raise a success event
          commitLocalAndToGlobalService(commit, FETCH_USER_REGISTRATION_DETAILS_SUCCESS, { "Status": Enums.UserRegistrationStatus.RegisteredUnconfirmedWithoutAccount });
          commitLocalAndToGlobalService(commit, SET_USER_PRIMARY_EMAIL, error.response.data.EmailAddress);   
        } else if(error.response && error.response.data) {
          commitLocalAndToGlobalService(commit, FETCH_FAILURE, error.response.data.Error);
        } else {
          globalCommit('service', commit, FETCH_FAILURE, Constants.ErrorMessages.GenericToasterErrorMessage);
        }
      }
    },

    async fetchMissingInformationStatus({ commit }, emailAddress) {
      globalCommit('service', commit, FETCH_UPDATE);
      try {
        const missingInfoStatus = await verifyUserInformation(emailAddress);
        commitLocalAndToGlobalService(commit, SET_MISSING_INFO_STATUS, missingInfoStatus.data);
      } catch (error) {
        globalCommit('service', commit, FETCH_FAILURE, Constants.ErrorMessages.GenericToasterErrorMessage);
      }
    },

    async fetchPrivacyPolicyConsentData({ commit }, emailAddress) {
      globalCommit('service', commit, FETCH_UPDATE);
      try {
        const privacyConsentData = await hasConsentedToPrivacyPolicy(emailAddress);
        commitLocalAndToGlobalService(commit, SET_PRIVACY_CONSENT_DATA, privacyConsentData.data);
      } catch (error) {
        globalCommit('service', commit, FETCH_FAILURE, Constants.ErrorMessages.GenericToasterErrorMessage);
      }
    },

    setEmailAddress({ commit }, emailAddress) {
      commit(USER_EMAIL_ADDRESS, emailAddress);
      storeEmailAddressInSession(emailAddress);
    },

    async onUserRegistrationStatus({ state, commit, dispatch, rootGetters }, emailAddress) {
      // Reset flags.
      commit(IS_VALID_EMAIL, true);
      commit(REDIRECT_PATH, '');
      commit(SET_PRIVACY_POLICY_ERROR_MESSAGE, '');
      commit(SET_MISSING_INFO_STATUS, null);
      const uniqueId = rootGetters['conferenceCall/GET_UNIQUE_ID'];
      const showId = uniqueId ? rootGetters['conferenceCall/GET_SHOW_ID'] : getUrlQueryParam();
      const confId = uniqueId ? rootGetters['conferenceCall/GET_CONF_ID'] : getAllUrlQueryParam('confId');
      await globalDispatch('presentation', dispatch, 'fetchPasswordDetails', showId);
      const { Id, PresId, RequireVerification } = rootGetters['conferenceCall/GET_CONFERENCE_CALL_DETAILS'];
      if(rootGetters['conferenceCall/GET_IS_SLIDE_LIVE_VIDEO'] || rootGetters['conferenceCall/GET_IS_SLIDE_CONF_SHOW']
        || rootGetters['conferenceCall/GET_IS_VIDEO_WEBINAR'] || rootGetters['conferenceCall/GET_IS_CONF_ONLY_SHOW']) {
        await dispatch('fetchPresenterRegBypass', { presId: PresId, emailAddress: emailAddress, confId: confId });
      }
      const { ShowPassword } = rootGetters['presentation/GET_PASSWORD_DETAILS'];
      const statusParams = {
        email : emailAddress,
        EntryCode : ShowPassword,
        confid : confId || Id,
        suppressConfEmail: !RequireVerification,
        showLink: showId,
        applicationId: 6,
        ListenOnly: rootGetters['conferenceCall/GET_IS_LISTEN_ONLY']
      }
      await dispatch('fetchMissingInformationStatus', emailAddress);
      await dispatch('protectedFetchUserRegistrationStatus', statusParams);
      const status = state.userRegistrationStatus.Status;
      dispatch('setEmailAddress', emailAddress);
      if (state.canBypassRegistration) {
        await dispatch('fetchPrivacyPolicyConsentData', emailAddress);
        if (state.privacyConsentData.hasConsentedToPrivacyPolicy) {
          commit(REDIRECT_PATH, '');
          dispatch('checkUserEmailVerifiedEmail');
        } else if (state.privacyConsentData.lastConsentedPrivacyPolicyVersion) {
          dispatch('setPrivacyPolicyModalFlag', true);
        } else {
          commit(REDIRECT_PATH, uniqueId ? 'register-new' : 'register');
        }
      }
      setTimeout(() => {
        dispatch('checkEmailValidation', status);
        dispatch('checkFirstTimeUser', status);
        dispatch('checkUserMissingInfoAndVerified', status);
        dispatch('checkPrivacyPolicyAcceptance', emailAddress);
      }, 0)
    },

    checkEmailValidation({ commit }, status) {
      const isValid = !(status & Enums.UserRegistrationStatus.InvalidEmail);
      commit(IS_VALID_EMAIL, isValid);
    },

    async checkFirstTimeUser({ state, commit, rootGetters }, status) {
      if (!state.isValidEmail || state.canBypassRegistration) return;
      const isFirstTimeUser = status & Enums.UserRegistrationStatus.Unregistered;
      const uniqueId = rootGetters['conferenceCall/GET_UNIQUE_ID'];
      let redirectUrl = '';
      if (isFirstTimeUser) redirectUrl = uniqueId ? 'register-new' : 'register';
      commit(REDIRECT_PATH, redirectUrl);
    },
    async checkUserMissingInfoAndVerified({ commit, state, rootGetters, dispatch }, status) {
      if (state.redirectTo || !state.isValidEmail || state.canBypassRegistration) return;
      const brandingData = rootGetters['corporateBranding/getBrandingInfo'];
      let shouldSkipMissingInfoPage = false;
      if (brandingData && brandingData.RegistrationFields) {
        shouldSkipMissingInfoPage = skipMissingInfoPage({ RegistrationFields: brandingData.RegistrationFields, MissingInformation: state.isMissingInformation });
      }
      if (state.isMissingInformation.IsMissingFields && !shouldSkipMissingInfoPage) {
        const isNotVerified = status & Enums.UserRegistrationStatus.RegisteredWithUnconfirmedAccount ||
          status & Enums.UserRegistrationStatus.RegisteredUnconfirmedWithoutAccount;
        const { RequireVerification } = rootGetters['conferenceCall/GET_CONFERENCE_CALL_DETAILS'];
        const uniqueId = rootGetters['conferenceCall/GET_UNIQUE_ID'];
        if (uniqueId) {
          const redirectUrl = isNotVerified && RequireVerification ? 'validation-new' : 'register-new';
          commit(REDIRECT_PATH, redirectUrl);
        } else {
          const redirectUrl = isNotVerified && RequireVerification ? 'validation' : 'register';
          commit(REDIRECT_PATH, redirectUrl);
        }
      }
    },

    async checkPrivacyPolicyAcceptance({ state, commit, dispatch }, emailAddress) {
      if (state.redirectTo || !state.isValidEmail) return;
      globalCommit('service', commit, FETCH_UPDATE);
      try {
        if (!state.canBypassRegistration) {
          const privacyConsentData = await hasConsentedToPrivacyPolicy(emailAddress);
          globalCommit('service', commit, FETCH_UPDATE);
          if (!privacyConsentData.data.hasConsentedToPrivacyPolicy) {
            dispatch('setPrivacyPolicyModalFlag', true);
          } else {
            dispatch('checkUserVerifiedHisEmail');
            dispatch('checkUserEmailVerifiedEmail');
          }
        }
      }
      catch (error) {
        globalCommit('service', commit, FETCH_UPDATE);
      }
    },

    checkUserVerifiedHisEmail({ state, commit, rootGetters }) {
      if (state.redirectTo || !state.isValidEmail) return;
      
      const status = state.userRegistrationStatus.Status;
      const isVerified = status & Enums.UserRegistrationStatus.RegisteredWithUnconfirmedAccount ||
        status & Enums.UserRegistrationStatus.RegisteredUnconfirmedWithoutAccount;
      const { RequireVerification } = rootGetters['conferenceCall/GET_CONFERENCE_CALL_DETAILS'];
      const uniqueId = rootGetters['conferenceCall/GET_UNIQUE_ID'];
      if (uniqueId) {
        const redirectUrl = isVerified && RequireVerification ? 'validation-new' : '';
        commit(REDIRECT_PATH, redirectUrl);
      } else {
        const redirectUrl = isVerified && RequireVerification ? 'validation' : '';
        commit(REDIRECT_PATH, redirectUrl);
      }
    },

    checkUserMissingInformation({ state, commit, rootGetters }) {
      if (state.redirectTo || !state.isValidEmail) return;
      const uniqueId = rootGetters['conferenceCall/GET_UNIQUE_ID'];
      if (uniqueId) {
        const redirectUrl = state.isMissingInformation.IsMissingFields ? 'register-new' : '';
        commit(REDIRECT_PATH, redirectUrl);
      } else {
        const redirectUrl = state.isMissingInformation.IsMissingFields ? 'register' : '';
        commit(REDIRECT_PATH, redirectUrl);
      }
    },

    async checkUserEmailVerifiedEmail({ state, commit, dispatch, rootGetters }) {
      if (state.redirectTo) return; // if redirection url exists break this.

      const status = state.userRegistrationStatus.Status;
      const isEmailVerified = status & Enums.UserRegistrationStatus.RegisteredWithoutAccount ||
        status & Enums.UserRegistrationStatus.RegisteredWithAccount;
      const { RequireVerification } = rootGetters['conferenceCall/GET_CONFERENCE_CALL_DETAILS'];
      if (isEmailVerified || !RequireVerification || state.canBypassRegistration) {
        /** Create user session */
        const logId = rootGetters['presentation/GET_LOG_ID'];
        if (logId) {
          await dispatch('getLoggedInUserDetails');

          /** Fetch presentation details */
          const { Id, PresId, AskForPublicPrivate, AskForSalesRep } = rootGetters['conferenceCall/GET_CONFERENCE_CALL_DETAILS'];

          const isSmallGroupMeetingType = rootGetters['conferenceCall/GET_IS_SMALL_GROUP_MEETING_TYPE'];
          if (!isSmallGroupMeetingType) {
            await globalDispatch('conferenceCall', dispatch, 'getRegisteredUserForCall');
          }
          
          const { IsRegistered, Metadata } = rootGetters['conferenceCall/GET_REGISTERED_USER_FOR_CALL'];
          const IsPublicParticipantValue = rootGetters['conferenceCall/GET_PUBLIC_PARTICIPANT'];
          const IsUserPresenter = state.isUserPresenter;
          const SalesRepValue = rootGetters['conferenceCall/GET_SALES_REP'];
          const barndingData = rootGetters['corporateBranding/getBrandingInfo'];
          let hasRegistrationFields = false;
          if(barndingData && barndingData.RegistrationFields){
            hasRegistrationFields = barndingData.RegistrationFields.some((val) => {
              return val.Name!=='AccountType' && val.Name!=='CompanyRole' && val.Name !== 'PhoneNumber' && !val.IsDeleted;
            });
          }
          var additionalInstructionsPresent = false;
          if(barndingData && barndingData.CustomMessages){
            additionalInstructionsPresent = barndingData.CustomMessages.some((val) => {
              return val.Key==='AdditionalInstructions' && val.Value!=="";
            });
          }
          /** 
           * Check whether the user has registered before and
           * redirect to the appropriate page.
           */
          const uniqueId = rootGetters['conferenceCall/GET_UNIQUE_ID'];
          if (!IsRegistered) {
            if((AskForPublicPrivate && !IsUserPresenter) || additionalInstructionsPresent || hasRegistrationFields){
              commit(REDIRECT_PATH, uniqueId ? 'supplemental-register-new' : 'supplemental-register');
            } else {
                if (AskForPublicPrivate && IsUserPresenter) {
                  sessionStorage.setItem(Constants.SessionStorageKeys.IsPublicParticipant, false);
                }
                await globalDispatch('presentation', dispatch, 'fetchDisclaimers');
                const Disclaimers = rootGetters['presentation/GET_DISCLAIMERS'];
                
                if (Disclaimers && !!Disclaimers.length) {
                  commit(REDIRECT_PATH, uniqueId ? 'disclaimer-new' : 'disclaimer');
                } else {
                  if (!isSmallGroupMeetingType) {
                    await globalDispatch('conferenceCall', dispatch, 'registerForConferenceCall');
                  }
                  commit(REDIRECT_PATH, uniqueId ? 'call-confirmation-new' : 'call-confirmation');
                }
              }
          } else {
            if (AskForPublicPrivate && IsPublicParticipantValue === null && IsUserPresenter && !additionalInstructionsPresent) {
              sessionStorage.setItem(Constants.SessionStorageKeys.IsPublicParticipant, false);
                await globalDispatch('conferenceCall', dispatch, 'updateRegisteredParticipantForConferenceCall');
                commit(REDIRECT_PATH, uniqueId ? 'call-confirmation-new' : 'call-confirmation');
            }
            else {
              sessionStorage.setItem(Constants.SessionStorageKeys.IsPublicParticipant, IsPublicParticipantValue);
              // If Registered but declaration is missing then ask to fill declaration first
              if (((AskForPublicPrivate && IsPublicParticipantValue === null) || additionalInstructionsPresent)) {
                commit(REDIRECT_PATH, uniqueId ? 'supplemental-register-new' : 'supplemental-register');
              }
              else {
                commit(REDIRECT_PATH, uniqueId ? 'call-confirmation-new' : 'call-confirmation');
              }
            }
          }
        }
      }
    },

    async saveNewUser({ commit, rootGetters }, param) {
      const isSGMType = rootGetters['conferenceCall/GET_IS_SMALL_GROUP_MEETING_TYPE'];
      globalCommit('service', commit, FETCH_UPDATE);
      try {
        await saveNewUser(param, isSGMType);
        commitLocalAndToGlobalService(commit, SAVE_NEW_USER_SUCCESS, 'Success'); // here response is empty so adding success message
      } catch (err) {
        const error = err.response.data ? err.response.data.Error : '';
        commitLocalAndToGlobalService(commit, SAVE_NEW_USER_FAILURE, error); // here response is empty so adding success message
      }
    },

    async savePrivacyPolicyConsent({ commit }, param) {
      globalCommit('service', commit, FETCH_UPDATE);
      try {
        await saveUserConsentToPolicy(param);
        commitLocalAndToGlobalService(commit, SAVE_NEW_USER_SUCCESS, 'Success'); // here response is empty so adding success message
      } catch (err) {
        const error = err.response.data ? err.response.data.Error : '';
        commitLocalAndToGlobalService(commit, SAVE_NEW_USER_FAILURE, error);
      }
    },

    async completeUserProfile({ commit, rootGetters }, param) {
      const isSGMType = rootGetters['conferenceCall/GET_IS_SMALL_GROUP_MEETING_TYPE'];
      globalCommit('service', commit, FETCH_UPDATE);
      try {
        await completeUserProfile(param, isSGMType);
        commitLocalAndToGlobalService(commit, COMPLETE_PROFILE_SUCCESS, 'Success');
      } catch (err) {
        globalCommit('service', commit, COMPLETE_PROFILE_FAILURE, Constants.ErrorMessages.GenericToasterErrorMessage);
      }
    },
    async confirmUserEmail({ commit, dispatch }, rowGuid) {
      globalCommit('service', commit, FETCH_UPDATE);
      try {
        const userDetails = await confirmRegisteredUserEmail(rowGuid);
        commitLocalAndToGlobalService(commit, POST_CONFIRM_EMAIL_SUCCESS, userDetails.data);
        dispatch('setEmailAddress', userDetails.data.EmailAddress);
      } catch (err) {
        commitLocalAndToGlobalService(commit, POST_CONFIRM_EMAIL_FAILURE, Constants.ErrorMessages.GenericToasterErrorMessage); // here response is empty so adding success message
      }
    },

    async getLoggedInUserDetails({ commit, rootGetters }) {
      globalCommit('service', commit, FETCH_UPDATE);
      try {
        const loggedInUser = await getLoggedInUserForPresentation();
        commitLocalAndToGlobalService(commit, FETCH_LOGGED_IN_USER_DETAILS_SUCCESS, loggedInUser.data);
      } catch (err) {
        const uniqueId = rootGetters['conferenceCall/GET_UNIQUE_ID'];
        if(uniqueId){
          location.replace('/events/login/' + uniqueId);
        } else {
          const showId = getUrlQueryParam();
          const confId = getAllUrlQueryParam('confId');
          if (confId) {
            const email = getAllUrlQueryParam('email');
            if(email){
              location.replace('/events/login?show=' + showId + '&confId=' + confId + '&email=' + email);
            }
            else{
              location.replace('/events/login?show=' + showId + '&confId=' + confId);
            }
          }
          else {
              location.replace('/events/login?show=' + showId);
            }
        }
      }
    },

    async getLoggedInUserDetailsWithoutRedirectOnError({ commit }) {
      globalCommit('service', commit, FETCH_UPDATE);
      try {
        const loggedInUser = await getLoggedInUserForPresentation(false);
        commitLocalAndToGlobalService(commit, FETCH_LOGGED_IN_USER_DETAILS_SUCCESS, loggedInUser.data);
      } catch (err) { }
    },

    async fetchUserInformation({ commit }, params) {
      globalCommit('service', commit, FETCH_UPDATE);
      try {
        const loggedInUser = await getUserInformation(params.email, params.show);
        commitLocalAndToGlobalService(commit, FETCH_USER_INFORMATION_SUCCESS, loggedInUser.data);
      } catch (err) {
        commitLocalAndToGlobalService(commit, FETCH_USER_INFORMATION_FAILURE, Constants.ErrorMessages.GenericToasterErrorMessage);
      }
    },

    async fetchCompanySuggestions({ commit }, email) {
      globalCommit('service', commit, FETCH_UPDATE);
      try {
        const companySuggestions = await getCompanySuggestions(email);
        commitLocalAndToGlobalService(commit, FETCH_COMPANY_SUGGESTIONS_SUCCESS, companySuggestions.data);
      } catch (err) {
        commitLocalAndToGlobalService(commit, FETCH_COMPANY_SUGGESTIONS_FAILURE, Constants.ErrorMessages.GenericToasterErrorMessage);
      }
    },

    async fetchCountries({ commit }) {
      globalCommit('service', commit, FETCH_UPDATE);
      try {
        const countries = await getCountries();
        commitLocalAndToGlobalService(commit, FETCH_COUNTRIES_SUCCESS, countries.data);
      } catch (err) {
        commitLocalAndToGlobalService(commit, FETCH_COUNTRIES_FAILURE, Constants.ErrorMessages.GenericToasterErrorMessage);
      }
    },

    async setPrivacyPolicyModalFlag({ commit }, showModal) {
      commit(SET_PRIVACY_POLICY_FLAG, showModal);
    },

    async updatePrivacyPolicyErrorMessage({ commit }, message) {
      commit(SET_PRIVACY_POLICY_ERROR_MESSAGE, message);
    },

    async getRedirectAfterProfileCompletion({ rootState, rootGetters }) {
      await onRouteInitialize();
      const isSGMType = rootGetters['conferenceCall/GET_IS_SMALL_GROUP_MEETING_TYPE'];
      const { IsRegistered } = rootGetters['conferenceCall/GET_REGISTERED_USER_FOR_CALL'];
      if (!isSGMType && !IsRegistered) {
        return await getRedirectUrlForNotRegisteredUser();
      } else {
        const uniqueId = rootGetters['conferenceCall/GET_UNIQUE_ID'];
        return uniqueId ? 'call-confirmation-new' : 'call-confirmation';
      }
    },

    async fetchAccountTypes({ commit }) {
      globalCommit('service', commit, FETCH_UPDATE);
      try {
        const accountTypes = await getAccountTypes();
        commitLocalAndToGlobalService(commit, FETCH_ACCOUNT_TYPES_SUCCESS, accountTypes.data);
      } catch (err) {
        commitLocalAndToGlobalService(commit, FETCH_ACCOUNT_TYPES_FAILURE, Constants.ErrorMessages.GenericToasterErrorMessage);
      }
    },

    async fetchCompanyRoles({state, commit}, { accountTypeId, refreshOnLangChange}) {
      
      if(state.companyRoles[accountTypeId] && !refreshOnLangChange){
        return;
      }
      globalCommit('service', commit, FETCH_UPDATE);
      try{
          const companyRoles = await getCompanyRoles(accountTypeId, !!refreshOnLangChange);
          if (refreshOnLangChange) {
            commitLocalAndToGlobalService(commit, RESET_COMPANY_ROLES_ON_LANG_CHANGE);
          }
          commitLocalAndToGlobalService(commit, FETCH_COMPANY_ROLES_SUCCESS, {accountId:accountTypeId , roles: companyRoles.data});
      } catch(err) {
        commitLocalAndToGlobalService(commit, FETCH_COMPANY_ROLES_FAILURE, Constants.ErrorMessages.GenericToasterErrorMessage);
      }
    },

    async fetchPresenterRegBypass({commit, rootGetters}, params) {
      globalCommit('service', commit, FETCH_UPDATE);
      try {
        let presenterRegBypass;
        if (rootGetters['conferenceCall/GET_IS_SLIDE_CONF_SHOW']|| rootGetters['conferenceCall/GET_IS_CONF_ONLY_SHOW']) {
          presenterRegBypass = await getPresenterRegBypass(params.presId, params.emailAddress, params.confId);
        } else {
          presenterRegBypass = await getPresenterRegBypass(params.presId, params.emailAddress);
        }
        commitLocalAndToGlobalService(commit, SET_PRESENTER_REG_BYPASS, presenterRegBypass.data.IsRegistrationBypassed);
        commitLocalAndToGlobalService(commit, SET_IS_USER_PRESENTER, presenterRegBypass.data.IsPresenter);
        sessionStorage.setItem(Constants.SessionStorageKeys.IsPresenter, presenterRegBypass.data.IsPresenter);
      } catch(err) {
        globalCommit('service', commit, FETCH_FAILURE, Constants.ErrorMessages.GenericToasterErrorMessage);
      }
    },


  },

  mutations: {

    [FETCH_USER_REGISTRATION_DETAILS_SUCCESS]: (state, userRegistrationStatus) => {
      state.userRegistrationStatus = userRegistrationStatus;
    },

    [SAVE_NEW_USER_SUCCESS]: (state, isRegisterPostSuccess) => {
      state.isRegisterPostSuccess = isRegisterPostSuccess;
    },

    [POST_CONFIRM_EMAIL_SUCCESS]: (state, isEmailConfirmed) => {
      state.isEmailConfirmed = isEmailConfirmed;
    },

    [IS_VALID_EMAIL]: (state, bool) => {
      state.isValidEmail = bool;
    },

    [REDIRECT_PATH]: (state, redirectTo) => {
      state.redirectTo = redirectTo;
    },

    [USER_EMAIL_ADDRESS]: (state, emailAddress) => {
      state.userEmailAddress = emailAddress;
    },

    [FETCH_LOGGED_IN_USER_DETAILS_SUCCESS]: (state, loggedInUser) => {
      state.loggedInUser = loggedInUser;
    },

    [FETCH_USER_INFORMATION_SUCCESS]: (state, user) => {
      state.userInformation = user;
    },

    [FETCH_COUNTRIES_SUCCESS]: (state, countries) => {
      state.countries = countries;
    },

    [SET_PRIVACY_POLICY_FLAG]: (state, showModal) => {
      state.showPrivacyPolicyModal = showModal;
    },

    [SET_PRIVACY_POLICY_ERROR_MESSAGE]: (state, message) => {
      state.privacyPolicyErrorMessage = message;
    },
    [SET_MISSING_INFO_STATUS]: (state, isMissingFields) => {
      state.isMissingInformation = isMissingFields;
    },
    [COMPLETE_PROFILE_SUCCESS]: (state, isCompleteProfileSuccess) => {
      state.isCompleteProfileSuccess = isCompleteProfileSuccess;
    },
    [SET_USER_PRIMARY_EMAIL]: (state, primaryEmail) => {
      state.primaryEmail = primaryEmail;
    },
    [FETCH_ACCOUNT_TYPES_SUCCESS]: (state, accountTypes) => {
      state.accountTypes = accountTypes;
    },
    [FETCH_COMPANY_ROLES_SUCCESS]: (state, data) => {
      state.companyRoles[data.accountId] = data.roles;
    },
    [RESET_COMPANY_ROLES_ON_LANG_CHANGE]: (state) => {
      state.companyRoles = {};
    },
    [SET_PRESENTER_REG_BYPASS]: (state, isRegBypassed) => {
      state.canBypassRegistration = isRegBypassed;
    },
    [FETCH_COMPANY_SUGGESTIONS_SUCCESS]: (state, companySuggestions) => {
      state.companySuggestions = companySuggestions;
    },
    [SET_IS_USER_PRESENTER]: (state, isUserPresenter) => {
      state.isUserPresenter = isUserPresenter;
    },
    [SET_PRIVACY_CONSENT_DATA]: (state, privacyConsentData) => {
      state.privacyConsentData = privacyConsentData;
    }
  },

  getters: {
    GET_USER_REGISTRATION_DETAILS: state => state.userRegistrationStatus,
    SAVE_NEW_USER: state => state.isRegisterPostSuccess,
    POST_CONFIRM_EMAIL: state => state.isEmailConfirmed,
    GET_REDIRECT_PATH: state => state.redirectTo,
    GET_IS_VALID_EMAIL: state => state.isValidEmail,
    GET_USER_EMAIL_ADDRESS: state => state.userEmailAddress,
    GET_LOGGED_IN_USER: state => state.loggedInUser,
    GET_USER_INFORMATION: state => state.userInformation,
    GET_COUNTRIES: state => state.countries,
    GET_PRIVACY_POLICY_MODAL_FLAG: state => state.showPrivacyPolicyModal,
    GET_PRIVACY_POLICY_ERROR_MESSAGE: state => state.privacyPolicyErrorMessage,
    GET_MISSING_INFO_STATUS: status => status.isMissingInformation,
    COMPLETE_PROFILE: state => state.isCompleteProfileSuccess,
    GET_USER_PRIMARY_EMAIL: state => state.primaryEmail,
    GET_ACCOUNT_TYPES: state => state.accountTypes,
    GET_COMPANY_ROLES: state => state.companyRoles,
    GET_COMPANY_SUGGESTIONS: state => state.companySuggestions,
    CAN_BYPASS_REG: state => state.canBypassRegistration,
    GET_IS_USER_PRESENTER: state => state.isUserPresenter,
  }
}
